<template>
  <div class="overnight-container">
    <el-row style="margin-bottom: 0.5rem">
      <template v-for="i in searchInput">
        <el-input
          :key="i.model"
          v-model="search[i.model]"
          style="width: 200px; margin-right: 10px"
          :placeholder="i.label"
          size="small"
        ></el-input>
      </template>
    </el-row>
    <el-row style="margin-bottom: 0.5rem">
      <el-select
        :placeholder="this.$t('app.ExceptionStatus')"
        v-model="search.case"
        style="width: 200px; margin-right: 10px"
        size="small"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-date-picker
        v-model="search.date"
        type="daterange"
        :clearable="false"
        range-separator="-"
        :start-placeholder="$t('app.startSearchDate')"
        :end-placeholder="$t('app.endSearchDate')"
        size="small"
        style="margin-right: 10px"
      >
      </el-date-picker>
      <el-checkbox
        label="是否已閱"
        v-model="search.isChecked"
        size="small"
        style="margin-right: 10px"
        @change="handleCheckChange"
      >
      </el-checkbox>
      <el-button type="primary" @click="reset" size="small">{{
        $t("app.reset")
      }}</el-button>
      <el-button
        type="success"
        @click="getList"
        icon="el-icon-search"
        size="small"
        >{{ $t("app.search") }}</el-button
      >
      <el-button
        type="primary"
        icon="el-icon-document"
        @click="handleDownload"
        size="small"
      >
        Export
      </el-button>
    </el-row>
    <div class="table-container">
      <el-table
        :data="tableData"
        height="580"
        style="width: 100%; color: black;"
        @sort-change="sortChange"
        :cell-style="cellStyle"
      >
        <el-table-column
          align="left"
          width="150px"
          :label="$t('app.operation')"
        >
          <template slot-scope="scope">
            <el-button
              size="small"
              :type="buttonType(scope.row)"
              @click="confirm(scope.row)"
              >{{
                scope.row.haveRead ? $t("app.haveRead") : $t("app.noRead")
              }}</el-button
            >
          </template>
        </el-table-column>
        <el-table-column type="expand">
          <template slot-scope="scope">
            <el-form label-position="left" class="demo-table-expand">
              <el-form-item label="中文名">
                <span>{{ scope.row.nameChina }}</span>
              </el-form-item>
              <el-form-item label="原因">
                <span>{{ scope.row.reason }}</span>
              </el-form-item>
              <el-form-item label="外宿目的地" style="margin-bottom: 0px">
                <span>{{ scope.row.destination }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <template v-for="col in column">
          <el-table-column
            v-if="
              col.model === 'room' ||
              col.model === 'date' ||
              col.model === 'studentNumber' ||
              col.model === 'submitDate'
            "
            :key="col.model"
            align="center"
            :label="col.label"
            :prop="col.model"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            v-else
            :key="col.model"
            align="center"
            :label="col.label"
            :prop="col.model"
          >
            <template slot-scope="scope">
              <template v-if="col.model === 'case'">
                <span
                  :style="{
                    color: scope.row[col.model] != '正常情況' ? 'red' : '#333',
                  }"
                  >{{ scope.row[col.model] }}</span
                >
              </template>
              <template v-else>
                {{ scope.row[col.model] }}
              </template>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
    <el-pagination
      style="text-align: center; margin-top: 20px"
      background
      :total="total"
      :current-page.sync="currentPage"
      @size-change="handleSizeChange"
      @current-change="getList"
      :page-sizes="[10, 50, 200, 1000]"
      :page-size="size"
      layout="total, sizes, prev, pager, next"
    >
    </el-pagination>
  </div>
</template>

<script>
import { getList, confirm } from "@/api/dormitoryManagement/overnight";
import { delEmpty, downloadFileByBlob, formatDate } from "@/utils/utils";
import { download } from "@/api/download";
import { black } from "color-name";
export default {
  components: {},
  data() {
    return {
      auto: false,
      time: "",
      loading: false,
      searchInput: [
        { model: "studentNumber", label: this.$t("app.studentNumber") },
        { model: "name", label: this.$t("app.name") },
        { model: "contact", label: this.$t("app.contactInformation") },
        { model: "room", label: this.$t("app.roomCode") },
      ],
      column: [
        { model: "nameEnglish", label: this.$t("app.nameEnglish") },
        { model: "studentNumber", label: this.$t("app.studentNumber") },
        {
          model: "contactInformation",
          label: this.$t("app.contactInformation"),
        },
        {
          model: "room",
          label: this.$t("app.roomCode"),
        },
        {
          model: "items",
          label: this.$t("app.declarationItems"),
        },
        {
          model: "date",
          label: this.$t("app.DateofReturnLateOrSleepOut"),
        },
        {
          model: "submitDate",
          label: this.$t("app.SubmitDate"),
        },
        {
          model: "case",
          label: this.$t("app.ExceptionStatus"),
        },
      ],
      search: {
        room: "",
        studentNumber: "",
        contact: "",
        name: "",
        case: "",
        date: [],
        orderKey: "",
        orderType: "",
        isChecked: false,
      },
      size: 10,
      currentPage: 1,
      total: 100,
      tableData: [],
      options: [
        {
          label: "正常情況",
          value: "1",
        },
        {
          label: "沒有申請但遲歸",
          value: "2",
        },
        {
          label: "沒有申請但外宿",
          value: "3",
        },
        {
          label: "申請遲歸但外宿",
          value: "4",
        },
      ],
    };
  },
  created() {
    this.getList();
    // this.search.case = this.options[0].value;
  },
  methods: {
    getList() {
      getList(
        delEmpty({
          OrderKey: this.search.orderKey,
          OrderType: this.search.orderType,
          RoomIndex: this.search.room,
          StudentName: this.search.name,
          StudentCode: this.search.studentNumber,
          ContactMobile: this.search.contact,
          Result: this.search.case,
          StartApplyDateTime: this.search.date[0] || "",
          EndApplyDateTime: this.search.date[1] || "",
          IsChecked: this.search.isChecked,
          PageIndex: this.currentPage,
          PageSize: this.size,
        })
      ).then((res) => {
        this.total = res.data.Total;
        let data = res.data.Items || [];
        this.tableData = data.map((item) => {
          return {
            id: item.Id,
            room: item.CurrentRoom,
            nameEnglish: item.EnglishName,
            studentNumber: item.StudentCode,
            reason: item.ApplyReason,
            case: item.Result,
            contactInformation: item.ContactMobile,
            date: item.ApplyDate,
            items: item.ApplyItem,
            nameChina: item.ChineseName,
            realTime: item.RealComeBackTime,
            destination: item.Destination,
            submitDate: item.CreateTime,
            haveRead: item.HaveRead,
          };
        });
      });
    },
    reset() {
      this.search.room = "";
      this.search.studentNumber = "";
      this.search.contact = "";
      this.search.name = "";
      this.search.case = "";
      this.search.date = [];
    },
    handleSizeChange(val) {
      this.size = val;
      this.getList();
    },
    handleDownload() {
      download(
        "/OvernightManagement/Export",
        delEmpty({
          RoomIndex: this.search.room,
          StudentName: this.search.name,
          StudentCode: this.search.studentNumber,
          ContactMobile: this.search.contact,
          Result: this.search.case,
          StartApplyDateTime: this.search.date[0] || "",
          EndApplyDateTime: this.search.date[1] || "",
        })
      ).then((content) => {
        var blobContent = new Blob([content]);
        downloadFileByBlob(
          blobContent,
          "Overnight Record-" + formatDate(new Date(), "yyyy-MM-dd") + ".xls"
        );
      });
    },
    sortChange(obj) {
      this.search.orderKey = obj.prop;
      this.search.orderType = obj.order;
      this.getList();
    },
    cellStyle(row) {
      if (row.row.haveRead) {
        return "background: rgb(238, 238, 238)";
      }
    },
    buttonType(row) {
      if (row.haveRead) {
        return "info";
      } else {
        return "success";
      }
    },
    confirm(row) {
      confirm({
        Id: row.id,
        HaveRead: row.haveRead,
      }).then(() => {
        this.success();
      });
    },
    success() {
      this.$message({
        message: this.$t("app.opeSuccess"),
        type: "success",
      });
      this.getList();
    },
    handleCheckChange(checked) {
      this.search.isChecked = checked;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
.overnight-container {
  background-color: #fff;
  padding: 15px;
  border: solid 1px #ccc;
  height: calc(100% - 100px);
  .table-container {
    height: calc(100% - 150px);
    overflow: auto;
  }
}
</style>
